function berechneVersandzeit1bis3() {
  return berechneVersandzeit(1, 3);
}

function berechneVersandzeit2bis7() {
  return berechneVersandzeit(2, 7);
}

function berechneVersandzeit4bis15() {
  return berechneVersandzeit(4, 15);
}

function berechneVersandzeit3month() {
  return berechneVersandzeit(30, 35);
}

function berechneVersandzeit(tageMin, tageMax) {
  let heute = new Date();

  // Nach 12 Uhr → nächsten Tag
  if (heute.getHours() >= 12) {
    heute.setDate(heute.getDate() + 1);
  }

  function addWerktage(startdatum, tage) {
    let datum = new Date(startdatum);
    while (tage > 0) {
      datum.setDate(datum.getDate() + 1);
      let tag = datum.getDay();
      // Freitag (5), Samstag (6) + Feiertage überspringen
      if (tag !== 5 && tag !== 6 && !istFeiertag(datum)) {
        tage--;
      }
    }
    return datum;
  }

  function istFeiertag(datum) {
    const feiertage = [
      '01-01', // Neujahr
      '05-01', // Tag der Arbeit
      '10-03', // Tag der Deutschen Einheit
      '12-25', // 1. Weihnachtstag
      '12-26'  // 2. Weihnachtstag
    ];
    return feiertage.includes(datum.toISOString().slice(5, 10));
  }

  let versandMin = addWerktage(heute, tageMin);
  let versandMax = addWerktage(heute, tageMax);

  let options = { year: 'numeric', month: 'long', day: 'numeric' };
  return `Voraussichtliche Lieferung (Ab Bestelldatum): ${versandMin.toLocaleDateString('de-DE', options)} - ${versandMax.toLocaleDateString('de-DE', options)}`;
}

document.addEventListener("DOMContentLoaded", function() {
  let versandElement = document.getElementById("versandzeit-anzeige");
  if (!versandElement) return;

  let barcodeTag = versandElement.getAttribute("data-barcode") || "";
  let versandText = "";

  if (barcodeTag.includes("1-3;;")) {
    versandText = berechneVersandzeit1bis3();
  } else if (barcodeTag.includes("2-7;;")) {
    versandText = berechneVersandzeit2bis7();
  } else if (barcodeTag.includes("4-15;;")) {
    versandText = berechneVersandzeit4bis15();
  } else if (barcodeTag.includes("3month;;")) {
    versandText = berechneVersandzeit3month();
  }

  versandElement.innerText = versandText || "Versandzeit nicht verfügbar";
});
